import { Identifiable } from '@/model/Identifiable';

export const mergeTags = (tags: Identifiable[], translated: Identifiable[]): Identifiable[] =>
  tags.map((tag) => translated.find((t) => t.id === tag.id) || tag);
